<div fxLayout="row" [fxLayoutAlign]="item.customField28">
    <button  (click)="openInNewWindow(item.customField11)" style="color:white" class="primary" mat-button [innerHTML]="item.title"></button>
</div>